import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Draggable from 'react-draggable';
import Paper from '@material-ui/core/Paper';
import {withStyles} from '@material-ui/core/styles';
import DialogStyles from '../../components/ModalDialog/DialogStyles'

interface IProps {
    message: string | JSX.Element;
    options: {
        title?: string | JSX.Element;
        actions?: {
            copy: string;
            onClick: any;
        }[];
        closeCopy?: string;
    };
    close: any;
}

function PaperComponent(props) {
    return (
        <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
            <Paper {...props}
                   style={{overflow: 'inherit', minWidth: '250px'}}
            />
        </Draggable>
    );
}

const ModalAlert = ({close, message, options, classes}: IProps) => {
    return (
        <Dialog
            PaperComponent={PaperComponent}
            open={true}
            keepMounted
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
            onClose={(event, reason) => {
                if (reason !== 'backdropClick') {
                    close(event)
                }
            }}
        >
            <DialogTitle id="draggable-dialog-title" onClose={close} style={{
                cursor: 'move'
            }}>
                {options.title}
                <IconButton aria-label="close" className={classes.dButton} onClick={() => {
                    if (options.close !== undefined)
                        options.close();
                    close();
                }}>
                    <CloseIcon/>
                </IconButton>
            </DialogTitle>
            <DialogContent
            >
                <DialogContentText id="alert-dialog-slide-description"
                                   style={{textAlign: 'center',width: options.width!==undefined?options.width:null }}
                >
                    {message}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                {options.actions &&
                    options.actions.map((action, index) => (
                        <Button
                            onClick={() => {
                                action.onClick();
                                close();
                            }}
                            color="primary"
                            key={index}
                        >
                            {action.copy}
                        </Button>
                    ))}
                <Button onClick={() => {
                    if (options.close !== undefined)
                        options.close();
                    close();
                }} color="primary">
                    {options.closeCopy || "Okay"}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
export default withStyles(DialogStyles)(ModalAlert);
